/*
 * Header Organism Component
 *
 */

import React from "react"
import { Link } from "gatsby"
import MainMenu from "../../molecules/mainMenu/mainMenu"

const Header = () => {
  return (
    <header className="header">
      <div className="header__inner-container">
        <div className="header__column">
          <Link to="/" className="header__logo-link">
            <span className="sr-only">return to home page</span>
            {/* <svg
              width="62"
              height="61"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              role="img"
            >
              <title>Bio-Futures for Transplanetary Habitats</title>
              <g clipPath="url(#a)">
                <path
                  d="M58.601 42.58a29.89 29.89 0 0 0 2.706-12.468c0-16.57-13.432-30-30-30-16.569 0-30 13.43-30 30 0 16.568 13.431 30 30 30 6.2.01 12.249-1.91 17.308-5.494a1.441 1.441 0 0 1-.86-.86 28.67 28.67 0 0 1-16.448 5.156c-15.907 0-28.802-12.895-28.802-28.802S15.4 1.31 31.307 1.31s28.802 12.895 28.802 28.802a28.72 28.72 0 0 1-2.099 10.813 4.99 4.99 0 0 1 .591 1.655Z"
                  fill="#FEFEFE"
                />
                <path
                  d="M55.25 48.19a5.024 5.024 0 0 1-1.734.262 28.976 28.976 0 0 1-3.588 3.634c.34.236.573.616.612 1.05a30.174 30.174 0 0 0 4.71-4.946Zm1.714-8.548a27.33 27.33 0 0 0 1.736-9.616c0-8.832-4.18-16.689-10.67-21.698.046.161.082.327.106.496 6.24 4.96 10.24 12.613 10.24 21.202 0 3.305-.593 6.47-1.677 9.398.091.07.18.143.265.218ZM51.546 48c.104.048.21.092.317.132-5.02 5.695-12.368 9.287-20.556 9.287-.957 0-1.903-.05-2.834-.145.08-.094.15-.196.21-.305.863.083 1.739.125 2.624.125 8.051 0 15.28-3.515 20.239-9.094Z"
                  fill="#FEFEFE"
                />
                <path
                  d="M55.474 38.732a25.456 25.456 0 0 0 .791-11.262c-.094.036-.19.066-.29.09.19 1.242.29 2.514.29 3.81 0 2.525-.376 4.963-1.074 7.261.096.03.19.065.283.101Zm-4.991 8.611c.078.063.158.123.24.181-4.634 5.562-11.611 9.102-19.416 9.102-.827 0-1.644-.04-2.45-.118a1.8 1.8 0 0 0 .04-.297c.794.076 1.597.115 2.41.115 7.707 0 14.598-3.493 19.176-8.983Zm-25.109 8.274c-7.44-1.814-13.573-6.963-16.726-13.773-.095.033-.193.06-.293.082 3.188 6.917 9.41 12.148 16.961 13.985.011-.1.03-.2.058-.294Z"
                  fill="#FEFEFE"
                />
                <path
                  d="M25.334 56.433C17.217 54.605 10.481 49.13 6.936 41.82a2.508 2.508 0 0 1-.473-.238c3.56 7.64 10.542 13.366 18.975 15.207a1.785 1.785 0 0 1-.104-.356ZM5.377 38.88a27.358 27.358 0 0 1-1.463-8.855c0-15.13 12.264-27.393 27.393-27.393.142 0 .283 0 .424.003a1.44 1.44 0 0 0-.022.325c-4.323-.07-8.6.9-12.469 2.829a3.59 3.59 0 0 0-2.093 1.162c-7.745 4.762-12.91 13.315-12.91 23.074 0 2.916.462 5.725 1.315 8.356a2.5 2.5 0 0 0-.176.5v-.001Z"
                  fill="#FEFEFE"
                />
                <path
                  d="M6.726 37.2a25.327 25.327 0 0 1-.676-5.83c0-8.454 4.152-15.937 10.528-20.52.043.09.09.18.14.268-6.28 4.532-10.369 11.914-10.369 20.25 0 1.967.228 3.88.658 5.716-.096.033-.189.072-.28.116ZM23.09 7.795a24.92 24.92 0 0 1 8.217-1.384c2.098 0 4.136.26 6.082.747.01-.103.031-.2.066-.293a25.311 25.311 0 0 0-6.148-.753c-2.93 0-5.742.498-8.358 1.415.05.087.098.177.141.268Zm16.428-.319c-.022.1-.057.194-.104.281.572.197 1.136.414 1.688.65.026-.098.056-.194.09-.288a25.102 25.102 0 0 0-1.674-.643Zm4.044-1.59c.162-.049.328-.085.498-.109a27.209 27.209 0 0 0-9.478-2.95c.006.109-.001.217-.02.324 3.137.376 6.184 1.301 9 2.734Zm3.668 5.876c-.068.074-.139.145-.213.213a25.014 25.014 0 0 1 7.696 10.712 2.44 2.44 0 0 1 .297-.06 25.314 25.314 0 0 0-7.78-10.865ZM31.307 49.25c10.57 0 19.137-8.569 19.137-19.138 0-2.935-.66-5.716-1.84-8.2a3.608 3.608 0 0 1-.327.211 18.681 18.681 0 0 1 1.782 7.99c0 10.355-8.396 18.751-18.752 18.751-4.52 0-8.667-1.6-11.906-4.264a3.5 3.5 0 0 1-.258.287 19.06 19.06 0 0 0 12.164 4.363ZM14.56 39.383a19.05 19.05 0 0 1-2.39-9.27c0-10.57 8.568-19.139 19.137-19.139a19.07 19.07 0 0 1 13.046 5.136c-.105.077-.205.16-.3.247a18.687 18.687 0 0 0-12.746-4.997c-10.357 0-18.752 8.395-18.752 18.752 0 3.29.847 6.38 2.334 9.068-.113.062-.223.13-.329.203Z"
                  fill="#FEFEFE"
                />
                <path
                  d="M38.995 37.224a10.436 10.436 0 0 0 2.785-7.112c0-5.785-4.689-10.474-10.473-10.474-5.784 0-10.473 4.69-10.473 10.474s4.689 10.473 10.473 10.473c1.766 0 3.43-.437 4.89-1.21a1.74 1.74 0 0 1-.268-.294 10.045 10.045 0 0 1-4.622 1.12c-5.572 0-10.088-4.518-10.088-10.089 0-5.572 4.516-10.088 10.088-10.088 5.571 0 10.088 4.516 10.088 10.088 0 2.61-.99 4.987-2.616 6.778.083.102.156.215.216.334Z"
                  fill="#FEFEFE"
                />
                <path
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M16.772 38.75a16.87 16.87 0 0 1-2.415-8.724c0-9.36 7.589-16.95 16.95-16.95 4.575 0 8.726 1.813 11.775 4.76a3.594 3.594 0 0 0 3.466 4.767 16.88 16.88 0 0 1 1.709 7.423c0 9.361-7.59 16.95-16.95 16.95a16.884 16.884 0 0 1-11.137-4.172 3.597 3.597 0 0 0-3.398-4.054Zm27.98-6.34c-1.127 6.403-6.718 11.27-13.445 11.27-7.54 0-13.653-6.114-13.653-13.654 0-3.026.985-5.823 2.652-8.087a1.077 1.077 0 0 1 .613-1.966c.312 0 .593.132.79.344a13.609 13.609 0 0 1 9.598-3.943c7.387 0 13.404 5.866 13.645 13.195a1.439 1.439 0 0 1-.2 2.841Z"
                  fill="#FEFEFE"
                />
                <path
                  d="M31.271 36.373a6.292 6.292 0 1 0 0-12.584 6.292 6.292 0 0 0 0 12.584Z"
                  fill="url(#b)"
                />
                <path
                  d="M53.602 47.878a4.494 4.494 0 1 0 0-8.988 4.494 4.494 0 0 0 0 8.988ZM19.804 12.355a3.056 3.056 0 1 0 0-6.112 3.056 3.056 0 0 0 0 6.112ZM44.541 12.355a3.056 3.056 0 1 0 0-6.112 3.056 3.056 0 0 0 0 6.112Z"
                  fill="#FEFEFE"
                />
                <path
                  d="M46.447 22.027a3.056 3.056 0 1 0 0-6.112 3.056 3.056 0 0 0 0 6.112Z"
                  fill="#00FFBF"
                />
                <path
                  d="M16.568 45.361a3.056 3.056 0 1 0 0-6.112 3.056 3.056 0 0 0 0 6.112Z"
                  fill="#FEFEFE"
                />
                <path
                  d="M7.79 41.407a1.978 1.978 0 1 0 0-3.956 1.978 1.978 0 0 0 0 3.956Z"
                  fill="#E100FF"
                />
                <path
                  d="M55.327 27.061a1.978 1.978 0 1 0 0-3.956 1.978 1.978 0 0 0 0 3.956ZM9.845 33.209a1.438 1.438 0 1 0 0-2.876 1.438 1.438 0 0 0 0 2.876ZM37.35 39.249a1.258 1.258 0 1 0 0-2.516 1.258 1.258 0 0 0 0 2.516Z"
                  fill="#FEFEFE"
                />
                <path
                  d="M27.067 57.332a1.258 1.258 0 1 0 0-2.516 1.258 1.258 0 0 0 0 2.516Z"
                  fill="#00FFBF"
                />
                <path
                  d="M8.904 28.427a.719.719 0 1 0 0-1.438.719.719 0 0 0 0 1.438Z"
                  fill="#FEFEFE"
                />
                <path
                  d="M33.11 3.762a.899.899 0 1 0 0-1.798.899.899 0 0 0 0 1.798ZM44.613 31.838a.899.899 0 1 0 0-1.798.899.899 0 0 0 0 1.798ZM49.071 54.13a.899.899 0 1 0 0-1.799.899.899 0 0 0 0 1.798Z"
                  fill="#FFDF28"
                />
                <path
                  d="M56.73 10.696a.719.719 0 1 0 0-1.438.719.719 0 0 0 0 1.438ZM38.429 8.036a.683.683 0 1 0 0-1.366.683.683 0 0 0 0 1.366Z"
                  fill="#FEFEFE"
                />
                <path
                  d="M20.883 21.626a.611.611 0 1 0 0-1.222.611.611 0 0 0 0 1.222Z"
                  fill="#E100FF"
                />
                <path
                  d="M47.938 47.806a.54.54 0 1 0 0-1.078.54.54 0 0 0 0 1.078ZM35.267 51.864a.539.539 0 1 0 0-1.078.539.539 0 0 0 0 1.078Z"
                  fill="#FEFEFE"
                />
              </g>
              <defs>
                <linearGradient
                  id="b"
                  x1="34.08"
                  y1="33.029"
                  x2="26.17"
                  y2="27.564"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#F0F" />
                  <stop offset="1" stopColor="#0FF" />
                </linearGradient>
                <clipPath id="a">
                  <path fill="#fff" d="M.5 0h61v61H.5z" />
                </clipPath>
              </defs>
            </svg> */}
            <svg
              width="60"
              height="60"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              role="img"
            >
              <title>Bio-Futures for Transplanetary Habitats</title>
              <g clipPath="url(#a)">
                <mask
                  id="b"
                  style={{ maskType: "luminance" }}
                  maskUnits="userSpaceOnUse"
                  x="0"
                  y="0"
                  width="61"
                  height="61"
                >
                  <path d="M0 0h61v61H0V0Z" fill="#fff" />
                </mask>
                <g mask="url(#b)">
                  <path
                    d="M55.474 42.137A27.899 27.899 0 0 0 58 30.5c0-15.465-12.537-28-28-28-15.464 0-28 12.535-28 28 0 15.463 12.536 28 28 28a27.866 27.866 0 0 0 16.154-5.128 1.343 1.343 0 0 1-.803-.802A26.758 26.758 0 0 1 30 57.382c-14.847 0-26.882-12.035-26.882-26.882C3.118 15.653 15.153 3.618 30 3.618c14.846 0 26.882 12.035 26.882 26.882a26.805 26.805 0 0 1-1.96 10.092c.275.478.461 1.001.552 1.545Z"
                    fill="#FEFEFE"
                  />
                  <path
                    d="M52.347 47.373a4.69 4.69 0 0 1-1.619.244 27.035 27.035 0 0 1-3.348 3.392c.317.22.534.575.57.98a28.161 28.161 0 0 0 4.397-4.616Zm1.6-7.979a25.509 25.509 0 0 0 1.62-8.975c0-8.243-3.901-15.576-9.959-20.251.043.15.077.305.1.463 5.823 4.63 9.556 11.772 9.556 19.788 0 3.085-.553 6.04-1.565 8.772.085.065.168.133.248.203Zm-5.057 7.801c.097.045.196.086.296.123C44.5 52.634 37.642 55.986 30 55.986c-.893 0-1.776-.046-2.645-.135.075-.088.14-.183.196-.285.805.078 1.623.117 2.449.117 7.514 0 14.261-3.28 18.89-8.488Z"
                    fill="#FEFEFE"
                  />
                  <path
                    d="M52.556 38.545a23.757 23.757 0 0 0 .738-10.51 2.164 2.164 0 0 1-.27.083c.177 1.16.27 2.347.27 3.556 0 2.357-.35 4.632-1.002 6.777.09.028.177.06.264.094Zm-4.658 8.037c.072.06.147.115.224.17-4.325 5.19-10.837 8.494-18.122 8.494-.772 0-1.534-.037-2.287-.11a1.68 1.68 0 0 0 .038-.277c.74.071 1.49.107 2.249.107 7.193 0 13.625-3.26 17.898-8.384Zm-23.436 7.723c-6.944-1.693-12.668-6.5-15.61-12.855-.09.03-.18.056-.274.076 2.976 6.456 8.783 11.339 15.83 13.053.01-.093.028-.187.054-.274Z"
                    fill="#FEFEFE"
                  />
                  <path
                    d="M24.425 55.066C16.85 53.36 10.562 48.25 7.254 41.427a2.344 2.344 0 0 1-.442-.222c3.323 7.131 9.84 12.475 17.71 14.194a1.666 1.666 0 0 1-.097-.333ZM5.8 38.683a25.534 25.534 0 0 1-1.366-8.264C4.433 16.297 15.88 4.852 30 4.852c.132 0 .264 0 .396.003-.019.1-.026.202-.02.303a25.17 25.17 0 0 0-11.639 2.64 3.35 3.35 0 0 0-1.953 1.085C9.555 13.328 4.734 21.31 4.734 30.42c0 2.721.432 5.343 1.228 7.799-.071.15-.126.305-.164.466Z"
                    fill="#FEFEFE"
                  />
                  <path
                    d="M7.058 37.115a23.638 23.638 0 0 1-.631-5.441c0-7.89 3.875-14.875 9.826-19.152.04.084.084.168.13.25-5.86 4.23-9.677 11.12-9.677 18.9 0 1.836.213 3.621.614 5.335a2.38 2.38 0 0 0-.261.108h-.001ZM22.33 9.67A23.258 23.258 0 0 1 30 8.38c1.958 0 3.86.242 5.676.697.01-.096.03-.187.062-.274A23.624 23.624 0 0 0 30 8.1c-2.735 0-5.36.464-7.8 1.32a3.6 3.6 0 0 1 .13.25Zm15.332-.297c-.02.093-.053.18-.096.262.533.184 1.06.386 1.575.607.024-.092.052-.181.084-.27a23.405 23.405 0 0 0-1.563-.6Zm3.775-1.484a3.1 3.1 0 0 1 .465-.102 25.395 25.395 0 0 0-8.846-2.753c.005.101-.001.202-.019.302a25.112 25.112 0 0 1 8.4 2.553Zm3.423 5.484c-.063.07-.13.135-.198.199a23.346 23.346 0 0 1 7.183 9.998 2.28 2.28 0 0 1 .277-.056 23.626 23.626 0 0 0-7.262-10.141ZM30 48.362c9.865 0 17.861-7.998 17.861-17.862 0-2.74-.616-5.335-1.717-7.654-.098.071-.2.137-.305.197a17.435 17.435 0 0 1 1.663 7.458C47.502 40.165 39.665 48 30 48c-4.219 0-8.09-1.493-11.112-3.98a3.27 3.27 0 0 1-.241.269A17.79 17.79 0 0 0 30 48.362Zm-15.63-9.21a17.779 17.779 0 0 1-2.231-8.651c0-9.866 7.997-17.863 17.861-17.863a17.798 17.798 0 0 1 12.176 4.793c-.098.072-.191.15-.28.23A17.441 17.441 0 0 0 30 12.999c-9.667 0-17.502 7.835-17.502 17.502 0 3.07.79 5.954 2.179 8.463a3.591 3.591 0 0 0-.308.19Z"
                    fill="#FEFEFE"
                  />
                  <path
                    d="M37.175 37.138a9.741 9.741 0 0 0 2.6-6.638c0-5.4-4.377-9.776-9.775-9.776-5.398 0-9.775 4.378-9.775 9.776s4.377 9.775 9.775 9.775a9.724 9.724 0 0 0 4.564-1.13 1.624 1.624 0 0 1-.25-.274A9.376 9.376 0 0 1 30 39.916c-5.2 0-9.416-4.217-9.416-9.416 0-5.2 4.215-9.416 9.416-9.416 5.2 0 9.415 4.215 9.415 9.416a9.378 9.378 0 0 1-2.441 6.326c.077.095.145.2.201.312Z"
                    fill="#FEFEFE"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M16.434 38.562a15.745 15.745 0 0 1-2.254-8.142c0-8.736 7.083-15.82 15.82-15.82 4.27 0 8.144 1.692 10.99 4.442a3.353 3.353 0 0 0 3.235 4.45 15.755 15.755 0 0 1 1.595 6.928c0 8.736-7.084 15.82-15.82 15.82a15.758 15.758 0 0 1-10.395-3.894 3.358 3.358 0 0 0-3.171-3.784Zm26.114-5.917C41.496 38.62 36.278 43.163 30 43.163c-7.038 0-12.743-5.706-12.743-12.743 0-2.825.92-5.435 2.475-7.548a1.005 1.005 0 0 1 .572-1.835c.291 0 .554.123.738.32A12.702 12.702 0 0 1 30 17.678c6.894 0 12.51 5.476 12.735 12.316a1.343 1.343 0 0 1-.187 2.652Z"
                    fill="#FEFEFE"
                  />
                  <path
                    d="M29.966 36.343a5.873 5.873 0 1 0 0-11.745 5.873 5.873 0 0 0 0 11.745Z"
                    fill="url(#c)"
                  />
                  <path
                    d="M50.809 47.081a4.194 4.194 0 1 0 0-8.388 4.194 4.194 0 0 0 0 8.389ZM19.264 13.927a2.853 2.853 0 1 0 0-5.706 2.853 2.853 0 0 0 0 5.706Zm23.088 0a2.853 2.853 0 1 0 0-5.707 2.853 2.853 0 0 0 0 5.707Z"
                    fill="#FEFEFE"
                  />
                  <path
                    d="M44.13 22.954a2.852 2.852 0 1 0 0-5.704 2.852 2.852 0 0 0 0 5.704Z"
                    fill="#00FFBF"
                  />
                  <path
                    d="M16.244 44.732a2.852 2.852 0 1 0 0-5.704 2.852 2.852 0 0 0 0 5.704Z"
                    fill="#FEFEFE"
                  />
                  <path
                    d="M8.05 41.042a1.846 1.846 0 1 0 0-3.692 1.846 1.846 0 0 0 0 3.692Z"
                    fill="#E100FF"
                  />
                  <path
                    d="M52.419 27.653a1.846 1.846 0 1 0 0-3.691 1.846 1.846 0 0 0 0 3.69ZM9.969 33.39a1.342 1.342 0 1 0 0-2.685 1.342 1.342 0 0 0 0 2.685Zm25.671 5.637a1.174 1.174 0 1 0 0-2.348 1.174 1.174 0 0 0 0 2.348Z"
                    fill="#FEFEFE"
                  />
                  <path
                    d="M26.043 55.905a1.174 1.174 0 1 0 0-2.348 1.174 1.174 0 0 0 0 2.348Z"
                    fill="#00FFBF"
                  />
                  <path
                    d="M9.09 28.927a.67.67 0 1 0 0-1.342.67.67 0 0 0 0 1.342Z"
                    fill="#FEFEFE"
                  />
                  <path
                    d="M31.683 5.907a.839.839 0 1 0 0-1.678.839.839 0 0 0 0 1.678ZM42.419 32.11a.84.84 0 1 0 0-1.678.84.84 0 0 0 0 1.678Zm4.16 20.806a.84.84 0 1 0 0-1.68.84.84 0 0 0 0 1.68Z"
                    fill="#FFDF28"
                  />
                  <path
                    d="M53.728 12.379a.671.671 0 1 0 0-1.342.671.671 0 0 0 0 1.342Zm-17.08-2.483a.638.638 0 1 0 0-1.276.638.638 0 0 0 0 1.276Z"
                    fill="#FEFEFE"
                  />
                  <path
                    d="M20.271 22.58a.57.57 0 1 0 0-1.142.57.57 0 0 0 0 1.142Z"
                    fill="#E100FF"
                  />
                  <path
                    d="M45.522 47.014a.504.504 0 1 0 .062-1.005.504.504 0 0 0-.062 1.005Zm-11.826 3.788a.503.503 0 1 0 0-1.006.503.503 0 0 0 0 1.006Z"
                    fill="#FEFEFE"
                  />
                </g>
              </g>
              <defs>
                <linearGradient
                  id="c"
                  x1="32.588"
                  y1="33.222"
                  x2="25.205"
                  y2="28.122"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop stopColor="#F0F" />
                  <stop offset="1" stopColor="#0FF" />
                </linearGradient>
                <clipPath id="a">
                  <path fill="#fff" d="M0 0h60v60H0z" />
                </clipPath>
              </defs>
            </svg>
            <span className="sr-only">Return to home page.</span>
          </Link>
        </div>
        <div className="header__column">
          <MainMenu />
        </div>
      </div>
    </header>
  )
}

export default Header
